const middleware = {}

middleware['localeRedirect'] = require('../middleware/localeRedirect.js')
middleware['localeRedirect'] = middleware['localeRedirect'].default || middleware['localeRedirect']

middleware['trailingSlashRedirect'] = require('../middleware/trailingSlashRedirect.js')
middleware['trailingSlashRedirect'] = middleware['trailingSlashRedirect'].default || middleware['trailingSlashRedirect']

export default middleware
